var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMappreview(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.45 7.76222C23.9126 7.99337 24.4226 8.11371 24.9397 8.11371C25.4568 8.11371 25.9669 7.99337 26.4294 7.76222L32.5267 4.71277C32.7809 4.58573 33.0634 4.52582 33.3473 4.53875C33.6313 4.55168 33.9072 4.63702 34.1488 4.78664C34.3904 4.93627 34.5898 5.14522 34.7279 5.39362C34.866 5.64202 34.9383 5.92162 34.9379 6.20583V27.4753C34.9377 27.7847 34.8514 28.0879 34.6887 28.351C34.5259 28.6141 34.2931 28.8267 34.0164 28.965L26.4294 32.7593C25.9669 32.9905 25.4568 33.1108 24.9397 33.1108C24.4226 33.1108 23.9126 32.9905 23.45 32.7593L16.4313 29.25C15.9687 29.0188 15.4587 28.8985 14.9415 28.8985C14.4244 28.8985 13.9144 29.0188 13.4518 29.25L7.35459 32.2994C7.10022 32.4265 6.81756 32.4864 6.5335 32.4734C6.24944 32.4604 5.97344 32.3749 5.73175 32.2251C5.49006 32.0753 5.29074 31.8661 5.15274 31.6175C5.01474 31.3688 4.94266 31.089 4.94336 30.8047V9.53689C4.94353 9.22751 5.02982 8.92429 5.19257 8.66118C5.35533 8.39806 5.58811 8.18546 5.86486 8.04716L13.4518 4.25286C13.9144 4.0217 14.4244 3.90137 14.9415 3.90137C15.4587 3.90137 15.9687 4.0217 16.4313 4.25286L23.45 7.76222Z",
    stroke: "#90A1B9",
    strokeWidth: 3.33273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9395 8.11377V33.1092",
    stroke: "#90A1B9",
    strokeWidth: 3.33273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9414 3.90137V28.8968",
    stroke: "#90A1B9",
    strokeWidth: 3.33273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappreview);
export default __webpack_public_path__ + "static/media/mappreview.b64bef7ffdd29b024fd0aa6080b94a7a.svg";
export { ForwardRef as ReactComponent };